var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenuIssues = function SvgMenuIssues(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    fill: "#8D93AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14C4.65685 14 6 12.6569 6 11C6 9.34315 4.65685 8 3 8C1.34315 8 0 9.34315 0 11C0 12.6569 1.34315 14 3 14Z",
    fill: "#8D93AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22C4.65685 22 6 20.6569 6 19C6 17.3431 4.65685 16 3 16C1.34315 16 0 17.3431 0 19C0 20.6569 1.34315 22 3 22Z",
    fill: "#8D93AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 1H9C8.4 1 8 1.4 8 2V4C8 4.6 8.4 5 9 5H21C21.6 5 22 4.6 22 4V2C22 1.4 21.6 1 21 1Z",
    fill: "#8D93AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H9C8.4 9 8 9.4 8 10V12C8 12.6 8.4 13 9 13H21C21.6 13 22 12.6 22 12V10C22 9.4 21.6 9 21 9Z",
    fill: "#8D93AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17H9C8.4 17 8 17.4 8 18V20C8 20.6 8.4 21 9 21H21C21.6 21 22 20.6 22 20V18C22 17.4 21.6 17 21 17Z",
    fill: "#8D93AB"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuIssues);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu_issues.0da718c7a1d8ea839271cb2a3d0423b7.svg";